/* Switch Haircompany — thema-gedrag */
(function () {
  "use strict";

  function el(id) { return document.getElementById(id); }

  /* mobiel menu */
  var navToggle = el("navToggle");
  var mainNav = el("mainNav");
  if (navToggle && mainNav) {
    navToggle.addEventListener("click", function () {
      var open = mainNav.classList.toggle("is-open");
      navToggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* toast */
  var toastTimer;
  function toast(msg) {
    var t = el("toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("is-on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("is-on"); }, 2200);
  }

  /* aantal-steppers (productpagina + winkelwagen) */
  document.addEventListener("click", function (ev) {
    var btn = ev.target.closest("[data-qty-step]");
    if (!btn) return;
    var input = btn.parentElement.querySelector("input");
    if (!input) return;
    var next = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qtyStep, 10);
    input.value = Math.max(parseInt(input.min, 10) || 0, next);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* winkelwagen: aantal wijzigen = formulier opsturen */
  var cartForm = document.querySelector("form[data-cart-form]");
  if (cartForm) {
    cartForm.addEventListener("change", function (ev) {
      if (ev.target.matches("input[name='updates[]']")) cartForm.submit();
    });
  }

  /* variantkeuze: prijs + beschikbaarheid bijwerken */
  var productForm = document.querySelector("[data-product-form]");
  if (productForm) {
    var variantData = el("VariantData");
    var select = productForm.querySelector("select[name='id']");
    if (variantData && select) {
      var variants = JSON.parse(variantData.textContent);
      select.addEventListener("change", function () {
        var v = variants.find(function (x) { return String(x.id) === select.value; });
        if (!v) return;
        var priceEl = document.querySelector("[data-product-price]");
        if (priceEl && v.price_formatted) priceEl.textContent = v.price_formatted;
        var buyBtn = productForm.querySelector("[data-buy-button]");
        if (buyBtn) {
          buyBtn.disabled = !v.available;
          buyBtn.textContent = v.available ? buyBtn.dataset.labelAdd : buyBtn.dataset.labelSoldout;
        }
      });
    }

    /* toevoegen via AJAX zodat de klant op de pagina blijft */
    productForm.addEventListener("submit", function (ev) {
      ev.preventDefault();
      var buyBtn = productForm.querySelector("[data-buy-button]");
      if (buyBtn) buyBtn.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Accept": "application/json" },
        body: new FormData(productForm)
      }).then(function (r) {
        if (!r.ok) throw new Error("add-to-cart");
        return r.json();
      }).then(function () {
        return fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); });
      }).then(function (cart) {
        var count = document.querySelector(".cart-count");
        if (count) count.textContent = cart.item_count;
        toast("Toegevoegd aan je winkelwagen");
      }).catch(function () {
        toast("Toevoegen kon niet worden bevestigd. Controleer je winkelwagen voordat je opnieuw toevoegt.");
      }).finally(function () {
        if (buyBtn) buyBtn.disabled = false;
      });
    });
  }

  /* kassakoopjes op de winkelwagenpagina */
  document.addEventListener("click", function (ev) {
    var bump = ev.target.closest("[data-bump-add]");
    if (!bump) return;
    ev.preventDefault();
    bump.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: parseInt(bump.dataset.bumpAdd, 10), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error("bump");
      window.location.reload();
    }).catch(function () {
      bump.disabled = false;
      toast("Toevoegen lukte niet — probeer het nog eens");
    });
  });
})();

document.addEventListener('input',function(e){if(!e.target.matches('[data-brand-filter]'))return;const area=e.target.closest('section');const query=e.target.value.trim().toLocaleLowerCase('nl');area.querySelectorAll('[data-brand-name]').forEach(function(tile){tile.hidden=!tile.dataset.brandName.toLocaleLowerCase('nl').includes(query)});});
document.addEventListener('click',async function(e){const b=e.target.closest('[data-quick-add]');if(!b)return;b.disabled=true;try{const r=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:b.dataset.quickAdd,quantity:1}]})});if(!r.ok)throw Error();const t=document.getElementById('toast');t.textContent=b.dataset.success;t.classList.add('is-on');setTimeout(()=>t.classList.remove('is-on'),2500);const cart=await fetch((window.Shopify?.routes?.root||'/')+'cart.js').then(r=>r.json());document.querySelectorAll('.cart-count').forEach(n=>n.textContent=cart.item_count);}catch{const t=document.getElementById('toast');t.textContent=b.dataset.error;t.classList.add('is-on');setTimeout(()=>t.classList.remove('is-on'),4000);}finally{b.disabled=false;}});

document.addEventListener('click',function(e){const b=e.target.closest('[data-product-image]');if(!b)return;const main=b.closest('.product-grid').querySelector('.product-media img');if(!main)return;main.removeAttribute('srcset');main.src=b.dataset.productImage;main.alt=b.dataset.imageAlt;});
